export const getDeviceTypeFromRoute = route => {
  if (route.path.includes('/embed/')) {
    return 'embed';
  }
  if (route.path.includes('/desktop/')) {
    return 'desktop';
  }
  if (route.path.includes('/mobile/')) {
    return 'mobile';
  }
  return null;
};

export const getReferralType = route => (route.query.referralType ? route.query.referralType : null);
